import { create } from 'zustand'

// Connection state of the single shared cable (AnyCable multiplexes every channel over it).
export type CableStatus = 'idle' | 'connecting' | 'connected' | 'disconnected'

type State = {
  status: CableStatus
}

type Action = {
  setStatus: (status: CableStatus) => void
}

export const useCableStatusStore = create<State & Action>((set) => ({
  status: 'idle',
  setStatus: (status) => set({ status }),
}))
